<span class="site-info-directives">
  <img *ngIf="!hideIcon" [src]="icon" tooltip="{{ title }}" />
  <span *ngIf="!hideTitle">{{ title }}</span>
</span>
